import { useState } from 'react';
import SettingsIcon from '@mui/icons-material/Settings';
import { Box, Dialog, DialogContent, DialogTitle, Typography } from '@mui/material';
import { TertiaryNavigationIconButton } from 'components/ui';
import JobsColorSelector from 'dashboard409a/components/JobsColorSelector/JobsColorSelector';

const ValuationsTableConfigToggler = ({
  onPaletteClose,
}: {
  onPaletteClose?: () => void;
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <TertiaryNavigationIconButton
        ariaLabel="Settings"
        icon={<SettingsIcon />}
        tooltipTitle="Settings"
        variant="toolbar"
        onClick={() => setIsOpen(!isOpen)}
      />
      {isOpen && (
        <Dialog open={isOpen} onClose={() => setIsOpen(false)} maxWidth="sm" fullWidth>
          <DialogTitle>Settings</DialogTitle>
          <DialogContent>
            <Box sx={{ py: 2 }}>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                  Color Palette
                </Typography>
                <JobsColorSelector onClose={onPaletteClose} />
              </Box>
            </Box>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};

export default ValuationsTableConfigToggler;
